(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/simple-article/assets/javascripts/helpers/handlebar-helpers.js') >= 0) return;  svs.modules.push('/components/content/simple-article/assets/javascripts/helpers/handlebar-helpers.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  function registerHelpers(hbs) {
    hbs.registerHelper('json', function (context) {
      var arr = JSON.stringify(context);
      return arr === undefined ? '[]' : arr;
    });
    hbs.registerHelper('hasText', function (text, options) {
      var fnTrue = options.fn,
          fnFalse = options.inverse;
      return text !== '<p>&nbsp;</p>' ? fnTrue(this) : fnFalse(this);
    });
    hbs.registerHelper('addEllipsis', function (text) {
      return "".concat(text, "...");
    });
    hbs.registerHelper('showSummarized', function (text) {
      var aOpenTag = /<a href="(.*?)">/g,
          aCloseTag = /<\/a>/g;

      if (text !== '<p>&nbsp;</p>') {
        return "".concat(text.replace(aOpenTag, '').replace(aCloseTag, '').slice(0, 363), "...");
      }
    });
  }

  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }
})();
 })(window);